import { Hero, Marquee } from "../components/home/Hero";
import { CTA, Journals, Steps, Why } from "../components/home/Sections";
import { About, Audience, FAQ } from "../components/home/Content";
import { LookupSection } from "../components/home/LookupSection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <About />
      <Audience />
      <Why />
      <Steps />
      <Journals />
      <FAQ />
      <LookupSection />
      <CTA />
    </main>
  );
}
